import React, { useState, useEffect, useRef } from "react";

const PopupComponent = () => {
  const [dontShowDoMyBestAgain, setDontShowDoMyBestAgain] = useState(false);
  const [dontShowHolidayAgain, setDontShowHolidayAgain] = useState(false);
  const [dontShowJuneHolidayAgain, setDontShowJuneHolidayAgain] = useState(false);
  const [dontShowAugustHolidayAgain, setDontShowAugustHolidayAgain] = useState(false);
  const [dontShowAugustHoliday2Again, setDontShowAugustHoliday2Again] = useState(false);
  const [dontShowSeptemberHolidayAgain, setDontShowSeptemberHolidayAgain] = useState(false);
  const [dontShowOctoberHolidayAgain, setDontShowOctoberHolidayAgain] = useState(false);

  const [hideDoMyBestTemp, setHideDoMyBestTemp] = useState(false);
  const [hideHolidayTemp, setHideHolidayTemp] = useState(false);
  const [hideJuneHolidayTemp, setHideJuneHolidayTemp] = useState(false);
  const [hideAugustHolidayTemp, setHideAugustHolidayTemp] = useState(false);
  const [hideAugustHoliday2Temp, setHideAugustHoliday2Temp] = useState(false);
  const [hideSeptemberHolidayTemp, setHideSeptemberHolidayTemp] = useState(false);
  const [hideOctoberHolidayTemp, setHideOctoberHolidayTemp] = useState(false);

  const doMyBestRef = useRef(null);
  const holidayRef = useRef(null);
  const juneHolidayRef = useRef(null);
  const augustHolidayRef = useRef(null);
  const augustHoliday2Ref = useRef(null);
  const septemberHolidayRef = useRef(null);
  const octoberHolidayRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const popupRefs = [
        doMyBestRef,
        holidayRef,
        juneHolidayRef,
        augustHolidayRef,
        augustHoliday2Ref,
        septemberHolidayRef,
        octoberHolidayRef,
      ];

      // 어떤 팝업이든 그 내부(닫기 버튼/체크박스 포함)를 클릭한 경우에는
      // 다른 팝업까지 같이 닫히지 않도록 한다.
      if (
        popupRefs.some(
          (ref) => ref.current && ref.current.contains(event.target)
        )
      ) {
        return;
      }

      // 모든 팝업 바깥을 클릭한 경우에만 닫는다.
      if (shouldShowPopup("DoMyBest")) {
        setHideDoMyBestTemp(true);
      }
      if (shouldShowPopup("Holiday")) {
        setHideHolidayTemp(true);
      }
      if (shouldShowPopup("JuneHoliday")) {
        setHideJuneHolidayTemp(true);
      }
      if (shouldShowPopup("AugustHoliday")) {
        setHideAugustHolidayTemp(true);
      }
      if (shouldShowPopup("AugustHoliday2")) {
        setHideAugustHoliday2Temp(true);
      }
      if (shouldShowPopup("SeptemberHoliday")) {
        setHideSeptemberHolidayTemp(true);
      }
      if (shouldShowPopup("OctoberHoliday")) {
        setHideOctoberHolidayTemp(true);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleClose = (popup) => {
    const currentTime = new Date().getTime();

    if (popup === "DoMyBest") {
      if (dontShowDoMyBestAgain) {
        localStorage.setItem("hideDoMyBestPopup", currentTime);
      }
      setHideDoMyBestTemp(true);
    } else if (popup === "Holiday") {
      if (dontShowHolidayAgain) {
        localStorage.setItem("hideHolidayPopup", currentTime);
      }
      setHideHolidayTemp(true);
    } else if (popup === "JuneHoliday") {
      if (dontShowJuneHolidayAgain) {
        localStorage.setItem("hideJuneHolidayPopup", currentTime);
      }
      setHideJuneHolidayTemp(true);
    } else if (popup === "AugustHoliday") {
      if (dontShowAugustHolidayAgain) {
        localStorage.setItem("hideAugustHolidayPopup", currentTime);
      }
      setHideAugustHolidayTemp(true);
    } else if (popup === "AugustHoliday2") {
      if (dontShowAugustHoliday2Again) {
        localStorage.setItem("hideAugustHoliday2Popup", currentTime);
      }
      setHideAugustHoliday2Temp(true);
    } else if (popup === "SeptemberHoliday") {
      if (dontShowSeptemberHolidayAgain) {
        localStorage.setItem("hideSeptemberHolidayPopup", currentTime);
      }
      setHideSeptemberHolidayTemp(true);
    } else if (popup === "OctoberHoliday") {
      if (dontShowOctoberHolidayAgain) {
        localStorage.setItem("hideOctoberHolidayPopup", currentTime);
      }
      setHideOctoberHolidayTemp(true);
    }
  };

  const shouldShowPopup = (popup) => {
    const currentTime = new Date().getTime();
    const expirationTime = localStorage.getItem(`hide${popup}Popup`);
    const dayInMilliseconds = 86400000;

    const holidayStart = new Date("2026-02-19T00:00:00+09:00").getTime();
    const holidayEnd = new Date("2026-05-25T23:59:59+09:00").getTime();
    if (popup === "Holiday" && (currentTime < holidayStart || currentTime > holidayEnd)) {
      return false;
    }

    const juneHolidayEnd = new Date("2026-06-03T23:59:59+09:00").getTime();
    if (popup === "JuneHoliday" && currentTime > juneHolidayEnd) {
      return false;
    }

    const augustHolidayEnd = new Date("2026-08-06T23:59:59+09:00").getTime();
    if (popup === "AugustHoliday" && currentTime > augustHolidayEnd) {
      return false;
    }

    const augustHoliday2End = new Date("2026-08-17T23:59:59+09:00").getTime();
    if (popup === "AugustHoliday2" && currentTime > augustHoliday2End) {
      return false;
    }

    const septemberHolidayEnd = new Date("2026-09-26T23:59:59+09:00").getTime();
    if (popup === "SeptemberHoliday" && currentTime > septemberHolidayEnd) {
      return false;
    }

    const octoberHolidayEnd = new Date("2026-10-09T23:59:59+09:00").getTime();
    if (popup === "OctoberHoliday" && currentTime > octoberHolidayEnd) {
      return false;
    }

    return (
      !expirationTime ||
      currentTime >= parseInt(expirationTime) + dayInMilliseconds
    );
  };

  return (
    <div>
      {shouldShowPopup("OctoberHoliday") && !hideOctoberHolidayTemp && (
        <div className="popup october-holiday-popup" ref={octoberHolidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/260915_검단B_10월 휴진안내_정방.png`}
            alt="October Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowOctoberHolidayAgain}
                onChange={(e) =>
                  setDontShowOctoberHolidayAgain(e.target.checked)
                }
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("OctoberHoliday")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("SeptemberHoliday") && !hideSeptemberHolidayTemp && (
        <div className="popup september-holiday-popup" ref={septemberHolidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/260825_9월_이플러스휴진_1080.jpg`}
            alt="September Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowSeptemberHolidayAgain}
                onChange={(e) =>
                  setDontShowSeptemberHolidayAgain(e.target.checked)
                }
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("SeptemberHoliday")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("AugustHoliday2") && !hideAugustHoliday2Temp && (
        <div className="popup august-holiday2-popup" ref={augustHoliday2Ref}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/260805_8월휴진안내2_검단B_정방.png`}
            alt="August Holiday 2"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowAugustHoliday2Again}
                onChange={(e) => setDontShowAugustHoliday2Again(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("AugustHoliday2")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("AugustHoliday") && !hideAugustHolidayTemp && (
        <div className="popup august-holiday-popup" ref={augustHolidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/260720_8월휴진안내_검단B_정방.png`}
            alt="August Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowAugustHolidayAgain}
                onChange={(e) => setDontShowAugustHolidayAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("AugustHoliday")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("JuneHoliday") && !hideJuneHolidayTemp && (
        <div className="popup june-holiday-popup" ref={juneHolidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/260515_6월휴진안내_검단B_1080.webp`}
            alt="June Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowJuneHolidayAgain}
                onChange={(e) => setDontShowJuneHolidayAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("JuneHoliday")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("Holiday") && !hideHolidayTemp && (
        <div className="popup holiday-popup" ref={holidayRef}>
          <img
            src={`${process.env.PUBLIC_URL}/image/popup/0417pop.png`}
            alt="Holiday"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowHolidayAgain}
                onChange={(e) => setDontShowHolidayAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={() => handleClose("Holiday")}
            >
              닫기
            </button>
          </div>
        </div>
      )}

      {shouldShowPopup("DoMyBest") && !hideDoMyBestTemp && (
        <>
          {/* <div
            className="popup do-my-best-popup"
            ref={doMyBestRef}
            onMouseDown={(e) => e.stopPropagation()}
          >
          <img
            src={(() => {
              // 현재 시간을 KST(UTC+9)로 변환
              const now = new Date();
              const kstNow = new Date(now.getTime() + 9 * 60 * 60 * 1000);
              const kstTimestamp = kstNow.getTime();

              // 2025-08-15 23:59:59 KST를 UTC로 변환
              const kstDeadline = new Date(
                "2025-08-15T23:59:59+09:00"
              ).getTime();

              return kstTimestamp > kstDeadline
                ? `${process.env.PUBLIC_URL}/image/popup/domybest_after.png`
                : `${process.env.PUBLIC_URL}/image/popup/domybest.png`;
            })()}
            alt="Do My Best"
          />
          <div className="controls-container">
            <label>
              <input
                type="checkbox"
                checked={dontShowDoMyBestAgain}
                onChange={(e) => setDontShowDoMyBestAgain(e.target.checked)}
              />
              24시간 동안 다시 열람하지 않습니다.
            </label>
            <button
              className="closePopup"
              onClick={(e) => {
                e.stopPropagation();
                handleClose("DoMyBest");
              }}
            >
              닫기
            </button>
          </div>
        </div>
        */}
        </>
      )}

      <style jsx>{`
        .popup {
          position: absolute;
          top: 0;
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 1000;
          background: #fff;
          border: 1px solid #ccc;
          border-left: none;
        }
        .june-holiday-popup {
          width: 400px;
          left: 400px;
        }
        .august-holiday-popup {
          width: 400px;
        }
        .august-holiday2-popup {
          width: 400px;
          left: 400px;
        }
        .september-holiday-popup {
          width: 400px;
        }
        .october-holiday-popup {
          width: 400px;
        }
        .holiday-popup {
          width: 400px;
          left: 400px;
        }
        .do-my-best-popup {
          width: 400px;
          left: 400px;
        }
        .do-my-best-popup img,
        .holiday-popup img,
        .june-holiday-popup img,
        .august-holiday-popup img,
        .august-holiday2-popup img,
        .september-holiday-popup img,
        .october-holiday-popup img {
          width: 400px;
        }
        .controls-container {
          display: flex;
          justify-content: space-between;
          width: 100%;
          font-size: 12px;
          border: 1px solid #ccc;
        }
        .closePopup {
          background-color: white;
          border: none;
          color: black;
        }
        @media (max-width: 800px) {
          .popup {
            width: 90% !important;
            left: 5% !important;
            top: 100px !important;
          }
          .do-my-best-popup img,
          .holiday-popup img,
          .june-holiday-popup img,
          .august-holiday-popup img,
          .august-holiday2-popup img,
          .september-holiday-popup img,
          .october-holiday-popup img {
            width: 440px;
          }
        }
      `}</style>
    </div>
  );
};

export default PopupComponent;
